import {
  AfterViewInit,
  ContentChild,
  ContentChildren,
  Directive,
  Input,
  QueryList,
} from '@angular/core';
import { BehaviorSubject, merge } from 'rxjs';
import { ExpandablePanelDirective } from './expandable-panel.directive';
import { ExpandableToggleDirective } from './expandable-toggle.directive';

@Directive({
  selector: '[wzExpandable]',
  exportAs: 'wzExpandable',
  standalone: false,
})
export class ExpandableDirective implements AfterViewInit {
  @ContentChild(ExpandablePanelDirective, { static: true })
  expandablePanel!: ExpandablePanelDirective;
  @ContentChildren(ExpandableToggleDirective) expandableToggles =
    new QueryList<ExpandableToggleDirective>();
  // any;

  private isExpandedSubject = new BehaviorSubject<boolean>(false);
  public isExpanded = false;

  @Input()
  set wzExpandable(isExpanded: boolean) {
    this.toggle(isExpanded);
  }

  public toggle(isExpanded: boolean) {
    this.isExpandedSubject.next(!!isExpanded);
    this.isExpanded = isExpanded;
  }

  ngAfterViewInit() {
    if (this.expandablePanel) {
      this.init();
    }
  }

  private init() {
    this.isExpandedSubject.subscribe((isExpanded) => {
      this.expandablePanel.toggle(isExpanded);
      this.handleTogglesDisplay(isExpanded);
    });

    merge(...this.expandableToggles.map((t) => t.toggle)).subscribe(
      (isExpanded) => {
        this.toggle(isExpanded);
      },
    );
  }

  private handleTogglesDisplay(isExpanded: boolean) {
    this.expandableToggles.forEach((toggleComponent) => {
      if (isExpanded === toggleComponent.toggleValue) {
        toggleComponent.hide();
      } else {
        toggleComponent.show();
      }
    });
  }
}
